import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../AppContext';
import { useSearchParams } from 'react-router-dom';
// import QuickSightDashboard from '../../components/QuickSightDashboard/QuicksightDashboard';
import QuickSightDashboard2 from '../../components/QuickSightDashboard/QuicksightDashboard2';
// import NBAHeader from '../../components/NBAHeader/NBAHeader';
// import NBAEditorial from '../../components/NBAEditorial/NBAEditorial';


const BreakoutView = (props) => { 

    const { apiKey, availableDashboards, setMenuTitle, embedContext, realTime, hideHeader } = useContext(AppContext);
//   const {
//         dashboardId = "sales",
//         statx = "revenue",
//         staty = "profit",
//         year = "2024",
//     } = useParams();    
    // const params = useParams();
    // console.log('params',params)
    // const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    // const [position] = useState(searchParams.get("position") || "All Positions");
    // const [year] = useState(searchParams.get("year") || "All Records");

    const [statx, setStatx] = useState(searchParams?.get("x")?.toUpperCase() || 'HEIGHT')
    const [staty, setStaty] = useState(searchParams?.get("y")?.toUpperCase() || 'SHUTTLE RUN')
    const [year, setYear] = useState(searchParams?.get("year") || '2026')
    // const [dashboardId, setDashboardId] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.key)
    // const [dashboardTitle, setDashboardTitle] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.text)
    // const [dashboardType, setDashboardType] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.type)
    useEffect(() => {
        const nextStatx = searchParams?.get("x")?.toUpperCase() || 'HEIGHT';
        const nextStaty = searchParams?.get("y")?.toUpperCase() || 'SHUTTLE RUN';
        const nextYear = searchParams.get("year") || "2026";

        setStatx((prev) =>
        prev === nextStatx ? prev : nextStatx
        );
        setStaty((prev) =>
        prev === nextStaty ? prev : nextStaty
        );
        setYear((prev) =>
        prev === nextYear ? prev : nextYear
        );
    }, [searchParams]);
    
    const mobileRatio = 2;
    const desktopRatio = .9;

    const [mobile, setMobile] = useState(window.innerWidth < 768);
    // const [selectedDashboard, setSelectedDashboard] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0])
    const [height, setHeight] = useState(window.innerWidth < 768 ? window.innerWidth * mobileRatio : window.innerWidth * desktopRatio)


    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            // setViewportWidth(width);

            // update something when width changes
            if (width < 768) {
                setMobile(true);
                setHeight(window.innerWidth * mobileRatio);
            } else {
                setMobile(false);
                setHeight(window.innerWidth * desktopRatio);
            }
        };

        window.addEventListener("resize", handleResize);

        // run once on mount
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    
    useEffect(() => {

    }, [mobile])



    // useEffect(() => {
    //     if(!!params?.dashboardId && availableDashboards?.length >0) {
    //         // console.log('availableDashboards: ', availableDashboards);
    //         const dashboard = availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0];
    //         setSelectedDashboard(dashboard)
    //         // setDashboardId(dashboard?.key);
    //         // setDashboardType(dashboard?.type);
    //         // !!dashboard?.text && setDashboardTitle(dashboard?.text);
    //         !!dashboard?.text && setMenuTitle(dashboard?.text);  
    //     }

    // }, [params, availableDashboards])
    
    //eslint-disable-next-line
    let whatever = import.meta.env;



    return <>
        {/* <NBAHeader /> */}
        {/* <NBAEditorial items={defaultItems}/> */}
        <QuickSightDashboard2 
            key={!mobile ? availableDashboards[2]?.key : availableDashboards[3]?.key}
            dashboardId={!mobile ? availableDashboards[2]?.key : availableDashboards[3]?.key} 
            dashboardTitle={'AWS NBA Draft Combine 2026 Stat Lab'}
            dashboardType={'dashboard'}
            dashboardSubtype={""}
            apiKey={apiKey}
            realTime={realTime}
            embedContext={embedContext}
            height={height}
            dropdowns={['year','statx','staty']}
            initialParams={[{"Name":"DynamicStatA","Values":[statx]}, {"Name":"DynamicStatB","Values":[staty]}, {"Name":"DraftYear2","Values":[year === "All Records" ? "All Time" : year]}]}
            singleSheet={import.meta?.env?.VITE_HIDETABS ==="true" ? true : false}
        />
    </>
};

export default BreakoutView;